import { render, staticRenderFns } from "./UserArea.vue?vue&type=template&id=a46f5956&scoped=true"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"
import style0 from "./UserArea.vue?vue&type=style&index=0&id=a46f5956&prod&lang=scss&scoped=true"
import style1 from "./UserArea.vue?vue&type=style&index=1&id=a46f5956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46f5956",
  null
  
)

export default component.exports